import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos = {
      ...state.modulo.timbrado_masivo.archivos,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos.busy = true;
  });

  try {
    const response = await Http.get(`api/timbrado-masivo/${id}`, { params });

    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.busy = false;
      state.modulo.timbrado_masivo.archivos.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.busy = false;
      state.modulo.timbrado_masivo.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos = {
      ...initialState,
    };
  });
};

const TimbradoMasivoInfoStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    info,
    reset,
  },
};

export default TimbradoMasivoInfoStore;
